import { useState } from 'react';
import { useLazyGetCustomersAMLScoresHistoryByIdQuery } from '../../../customers/store/services/customers';
import { useLazyGetApplicationsAMLScoresHistoryByIdQuery } from '../../../new-application/store/services';
import { CustomerScore } from '../../types';

const useAmlChangeLogs = ({
  organizationId,
  applicationId,
}: {
  organizationId?: string;
  applicationId?: string;
}) => {
  const [selectedChangeLogId, setSelectedChangeLogId] = useState('');

  const [getCustomerAmlScoresHistoryById, { isLoading, isFetching }] =
    useLazyGetCustomersAMLScoresHistoryByIdQuery();
  const [
    getApplicationAmlScoresHistoryById,
    {
      isLoading: applicationAmlDetailsIsLoading,
      isFetching: applicationAmlDetailsIsFetching,
    },
  ] = useLazyGetApplicationsAMLScoresHistoryByIdQuery();

  const onCollapse = async ({
    amlChangeLog,
    evenChangeLog,
  }: {
    amlChangeLog?: CustomerScore;
    evenChangeLog?: CustomerScore;
  }) => {
    setSelectedChangeLogId(amlChangeLog?.id as string);

    const responses: {
      amlChangeLogDetails?: CustomerScore;
      evenChangeLogDetails?: CustomerScore;
    } = {};

    if (organizationId) {
      const almResponse = (await getCustomerAmlScoresHistoryById({
        id: organizationId,
        scoreId: amlChangeLog?.id as string,
      })) as { data: { data: CustomerScore } };

      if (almResponse?.data?.data) {
        responses.amlChangeLogDetails = almResponse?.data?.data;
      }

      if (evenChangeLog) {
        const eventReponse = (await getCustomerAmlScoresHistoryById({
          id: organizationId,
          scoreId: evenChangeLog.id,
        })) as { data: { data: CustomerScore } };

        if (eventReponse?.data?.data) {
          responses.evenChangeLogDetails = eventReponse?.data?.data;
        }
      }
    } else {
      const almResponse = (await getApplicationAmlScoresHistoryById({
        id: applicationId as string,
        scoreId: amlChangeLog?.id as string,
      })) as { data: { data: CustomerScore } };

      if (almResponse?.data?.data) {
        responses.amlChangeLogDetails = almResponse?.data?.data;
      }

      if (evenChangeLog) {
        const eventReponse = (await getApplicationAmlScoresHistoryById({
          id: applicationId as string,
          scoreId: evenChangeLog.id,
        })) as { data: { data: CustomerScore } };

        if (eventReponse?.data?.data) {
          responses.evenChangeLogDetails = eventReponse?.data?.data;
        }
      }
    }

    return responses;
  };

  return {
    onCollapse,
    isLoading,
    isFetching,
    applicationAmlDetailsIsLoading,
    applicationAmlDetailsIsFetching,
    selectedChangeLogId,
  };
};

export default useAmlChangeLogs;
